import Column from '@components/Column';
import { HTMLAttributes, ReactNode } from 'react';

import styles from './styles.module.scss';

interface Props {
    children?: ReactNode;
}
function Card({ children, className, ...rest }:HTMLAttributes<HTMLDivElement>) {
  return (
        <Column className={`${styles.container} ${className}`}
                aria-label='card'
                fullWidth
                {...rest}>
            {children}
        </Column>
  );
}

Card.Body = function Body({ children }:Props) {
  return (<Column spacing={12} fullWidth
                    className={styles.body} >
        {children}
    </Column>);
};

Card.Footer = function Footer({ children }:Props) {
  return (
        <Column align='center' justify='center' fullWidth className={ styles.footer}>
            {children}
        </Column>
  );
};
export default Card;
